/*eslint-disable*/
import React, { useState } from "react";
import { Link } from "react-router-dom";

import UserDropdown from "../../Components/Dropdowns/UserDropdown.js";

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = useState("hidden")
  const [showModal, setShowModal] = React.useState(false);
  const [shadow, setShadow] = useState(null)
  const [projectName, setProjectName] = useState("")

  // Data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  const [newProject, setNewProject] = useState([]);

  React.useEffect(() => {
    setLoading(true);
    fetch('https://warm-waters-06754.herokuapp.com/projects', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("token")),
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setData(data);
      })
      .catch((e) => {
        setLoading(false);
        setError('fetch failed');
      });
  }, [newProject]);

  const formOnSubmit = (evt) => {
    evt.preventDefault()
    setShowModal(false)
    fetch('https://warm-waters-06754.herokuapp.com/projects', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("token")),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ projectName })
    }).then((response) => response.json())
      .then((data) => {
        setNewProject(data)
      })
      .catch((e) => {
        console.log(e)
      });
  }

  return (
    <>
      <nav className="z-10">
        <div className="absolute left-0 top-0 flex-row flex-nowrap shadow-xl flex flex-wrap items-center justify-between w-full z-2 py-4 px-6">
          <div className="items-stretch min-h-full flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
            {/* Toggler */}
            <button
              className="cursor-pointer text-black opacity-50 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              type="button"
              onClick={() => { setCollapseShow("bg-white py-3 px-6"); setShadow("z-10") }}
            >
              <i className="fas fa-bars"></i>
            </button>
            {/* User */}
            <ul className="items-center flex flex-wrap list-none">
              <li className="inline-block relative">
                <UserDropdown userRole={"admin"} />
              </li>
            </ul>
            {/* Collapse */}
          </div>
        </div>

        <div className={"w-full h-screen fixed top-0 left-0 right-0 bottom-0 bg-darkBlue " + shadow} onClick={() => { setCollapseShow("hidden"); setShadow(null) }}>
          <div
            className={
              "w-46 flex flex-col items-stretch opacity-100 shadow-none shadow fixed top-0 left-0 right-0 bottom-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="min-w-full block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="block text-left pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    Uztelecom Infosystems
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => { setCollapseShow("hidden"); setShadow(null) }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Heading */}
            <h6 className="min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
              Admin Layout Pages
            </h6>
            {/* Navigation */}

            <ul className="flex-col min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/dashboard") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/dashboard"
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/dashboard") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Dashboard
                </Link>
              </li>

              <li className="items-center">
                <span
                  className="text-blueGray-700 text-xs uppercase py-3 font-bold flex flex-grow"
                >
                  <span className="mr-auto">
                    <i className="fas fa-tasks text-blueGray-400 mr-2 text-sm"></i>{" "}
                    Projects
                  </span>
                  <i className={"fas fa-angle-down text-blueGray-400 mr-2 text-sm"}></i>
                </span>
                {loading && <div
                  className={
                    "text-xs uppercase py-3 font-bold block text-blueGray-700 hover:text-blueGray-500"
                  }>
                  Loading...
                </div>}
                {/* {error && <div>{error.message}</div>} */}
                {data.length > 0 && (
                  <ul className={"flex-col min-w-full flex flex-col list-none ml-4"}>
                    {
                      data.map((project) => (
                        <li className="items-center" key={project.id}>
                          <Link
                            to={"/admin/projects/" + project.id}
                            params={{ id: project.id, name: project.name }}
                            className={
                              "text-xs uppercase py-3 font-bold block " +
                              (window.location.href.indexOf("/admin/projects/" + project.id) !== -1
                                ? "text-lightBlue-500 hover:text-lightBlue-600"
                                : "text-blueGray-700 hover:text-blueGray-500")
                            }>
                            {project.name}
                          </Link>
                        </li>
                      ))
                    }
                  </ul>

                )}
              </li>
              <li className="items-center">
                <button
                  className="w-full text-left text-xs uppercase py-3 font-bold block text-blueGray-700 hover:text-blueGray-500 focus:outline-none"
                  onClick={() => setShowModal(true)}>
                  <i
                    className="fas fa-plus mr-2 text-sm text-blueGray-300"
                  ></i>{" "}
                  Add project
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Modals */}

      {showModal ? (
        <div className="w-full h-screen fixed z-40 flex justify-center items-center bg-darkBlue">
          <div
            className="w-64 absolute mx-auto justify-center items-center flex overflow-x-hidden overflow-y-auto fixed z-50 outline-none focus:outline-none"
          >
            <div className="relative w-full my-6 mx-auto max-w-3xl">
              {/*content*/}
              <form
                className="border-0 rounded-lg p-5 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
                method="POST"
                action="/"
                onSubmit={formOnSubmit}
              >
                {/*header*/}
                <div className="flex items-start justify-between mb-4 pb-4 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-2xl font-semibold text-blueGray-700">
                    New project
                  </h3>
                  <button
                    className="cursor-pointer text-black opacity-50 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto flex flex-col mb-4">
                  <label htmlFor="project-name-input" className="text-xs uppercase py-3 font-bold block text-blueGray-700">Project name</label>
                  <input className="projectName border py-2 px-3 text-grey-darkest" type="text" id="project-name-input" placeholder="Project name" name="projectName" autoFocus onInput={(evt) => setProjectName(evt.target.value.trim())} />
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b mt-4 pt-6">
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="submit"
                  >
                    Add a new project
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </div>
      ) : null
      }
    </>
  );
}
